// SurveyRunner.tsx
import React, { useState, useEffect } from "react";

import { Model } from "survey-core";
import * as italian from "survey-core/i18n/italian";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import surveyService from "../services/survey-service";
import DashboardLayout from "../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../examples/Navbars/DashboardNavbar";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDButton from "../components/MDButton";
import surveyTheme from "./survey_theme.json";
import SurveyComponent from "./components/SurveyComponent";

export default function SurveyRunner() {
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const [isEditMode, setIsEditMode] = useState(false);
	const [responseId, setResponseId] = useState(null);
	const [viewOnly, setViewOnly] = useState(false);
	useEffect(() => {
		console.log("SurveyCompiler - Location changed:", {
			pathname: location.pathname,
			search: location.search,
			key: location.key,
		});
		const urlParams = new URLSearchParams(location.search);
		const _isEditMode = urlParams.get("edit") === "true";
		const _responseId = urlParams.get("id");
		const _viewOnly = urlParams.get("viewOnly") === "true";
		setIsEditMode(_isEditMode);
		setResponseId(_responseId);
		setViewOnly(_viewOnly);
	}, []);

	const handleBackToList = () => {
		if (isEditMode) {
			navigate("/survey-runner/list");
		} else {
			navigate("/survey-creator/list");
		}
	};

	const getPageTitle = () => {
		return isEditMode ? "Modifica Sondaggio" : "Compila Sondaggio";
	};

	const getPageDescription = () => {
		return isEditMode
			? "Modifica la tua risposta esistente"
			: "Compila il sondaggio con le tue risposte";
	};

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox py={3}>
				<MDBox
					mb={3}
					display="flex"
					justifyContent="space-between"
					alignItems="center"
				>
					<MDBox>
						<MDTypography variant="h4" fontWeight="medium">
							{getPageTitle()}
						</MDTypography>
						<MDTypography variant="body2" color="text">
							{getPageDescription()}
						</MDTypography>
					</MDBox>
					<MDButton
						variant="outlined"
						color="secondary"
						onClick={handleBackToList}
					>
						{isEditMode ? "Torna ai Compilati" : "Torna alla Lista"}
					</MDButton>
				</MDBox>

				<SurveyComponent
					surveyId={id}
					responseId={responseId}
					isEditMode={isEditMode}
					handleBackToList={handleBackToList}
					viewOnly={viewOnly}
				/>
			</MDBox>
		</DashboardLayout>
	);
}
